import { render } from "./person-center.vue?vue&type=template&id=19c1dea0&scoped=true"
import script from "./person-center.vue?vue&type=script&lang=js"
export * from "./person-center.vue?vue&type=script&lang=js"

import "./person-center.vue?vue&type=style&index=0&id=19c1dea0&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c1dea0"]])

export default __exports__